import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";

export default function NotFound() {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'Page non trouvée — LIFECUPP';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    meta.setAttribute('data-notfound-seo', 'true');
    document.head.appendChild(meta);

    return () => {
      document.querySelectorAll('meta[data-notfound-seo]').forEach((el) => el.remove());
    };
  }, []);

  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">Cette page n'existe pas</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-lg md:text-xl text-gray-500">
          La page que vous recherchez est introuvable.
        </p>
        <button
          onClick={() => navigate('/')}
          className="mt-8 px-6 py-2.5 bg-emerald-700 text-white rounded-md hover:bg-emerald-800 transition-colors cursor-pointer text-sm font-medium whitespace-nowrap"
        >
          Retour à l'accueil
        </button>
      </div>
    </div>
  );
}